import createIcon from '../../createIcon';

/**
 * @component @name PhoneEnabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMzggMTAuNzlMMTUuMTggOC41OUMxNC45IDguMzEgMTQuODIgNy45MiAxNC45MyA3LjU3QzE1LjMgNi40NSAxNS41IDUuMjUgMTUuNSA0QzE1LjUgMy40NSAxNS45NSAzIDE2LjUgM0gyMEMyMC41NSAzIDIxIDMuNDUgMjEgNEMyMSAxMy4zOSAxMy4zOSAyMSA0IDIxQzMuNDUgMjEgMyAyMC41NSAzIDIwVjE2LjUxQzMgMTUuOTYgMy40NSAxNS41MSA0IDE1LjUxQzUuMjQgMTUuNTEgNi40NSAxNS4zMSA3LjU3IDE0Ljk0QzcuOTIgMTQuODIgOC4zMiAxNC45MSA4LjU5IDE1LjE4TDEwLjc5IDE3LjM4QzEzLjYyIDE1LjkzIDE1Ljk0IDEzLjYyIDE3LjM4IDEwLjc5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneEnabled = createIcon('PhoneEnabled', [
  [
    'path',
    {
      d: 'M17.38 10.79L15.18 8.59C14.9 8.31 14.82 7.92 14.93 7.57C15.3 6.45 15.5 5.25 15.5 4C15.5 3.45 15.95 3 16.5 3H20C20.55 3 21 3.45 21 4C21 13.39 13.39 21 4 21C3.45 21 3 20.55 3 20V16.51C3 15.96 3.45 15.51 4 15.51C5.24 15.51 6.45 15.31 7.57 14.94C7.92 14.82 8.32 14.91 8.59 15.18L10.79 17.38C13.62 15.93 15.94 13.62 17.38 10.79Z',
      key: '18jr6r',
    },
  ],
]);

export default PhoneEnabled;
